import type { Component } from 'solid-js'
import type { IconProps } from './icon'

const Avatar: Component<IconProps> = (props) => {
  return (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class={`size-${props.size ?? 4}`}>
      <g clip-path="url(#clip0_145_635)">
        <path
          d="M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z"
          fill="#F3F4F6"
        />
        <path
          d="M19.9998 26C27.5133 26 33.6194 32.0261 33.7482 39.5091C33.7567 40.0054 33.4701 40.4593 33.019 40.6663C29.0544 42.4855 24.6448 43.4999 20.0014 43.5C15.3573 43.5 10.9458 42.486 6.98061 40.6663C6.52964 40.4593 6.24299 40.0053 6.25144 39.5091C6.38034 32.0263 12.4866 26.0002 19.9998 26Z"
          fill="#D1D5DC"
        />
        <path
          d="M19.9998 8.5C24.142 8.5 27.4998 11.8579 27.4998 16C27.4998 20.1421 24.142 23.5 19.9998 23.5C15.8578 23.4998 12.4998 20.142 12.4998 16C12.4998 11.858 15.8578 8.50018 19.9998 8.5Z"
          fill="#D1D5DC"
        />
      </g>
      <path
        d="M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z"
        stroke="#D1D5DC"
      />
      <defs>
        <clipPath id="clip0_145_635">
          <path
            d="M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Avatar
